import { gql } from '@apollo/client';

const PartnerLocationInfoShared = gql`
  fragment PartnerLocationInfoShared on PartnerLocation {
    id
    name
    email
    phone
    website
    active
    imageUrl
    insertImageUrl
    hiresLogoUrl
    legacyId
    isAllowedFreeTrial
    perArchEotFee
    scannerBrandId
    scannerBrand {
      id
      name
    }
    address {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerShippingAddress {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerOrganizationId
    partnerOrganization {
      id
      name
    }
    createdAt
    updatedAt
  }
`;

export default PartnerLocationInfoShared;
